import { HttpClient } from '../common/httpClient';
import { GetSelectedWhatsappTemplate, PostWhatsappTemplate, WhatsappTemplate } from '../../types/meta/whatsappTemplate';
import { fetchAllWhatsappTemplatesSynchronization } from './fetchAllWhatsappTemplatesSynchronization';

export class WhatsappTemplateApi {
  constructor(private readonly httpClient: HttpClient) {}

  private mapToWhatsappTemplate(response: WhatsappTemplate): WhatsappTemplate {
    return {
      name: response.name,
      status: response.status,
      category: response.category,
      language: response.language,
      whatsAppMessageTemplateId: response.whatsAppMessageTemplateId,
    };
  }

  private mapToSelectedWhatsappTemplate(response: GetSelectedWhatsappTemplate): GetSelectedWhatsappTemplate {
    return {
      name: response.name,
      status: response.status,
      category: response.category,
      language: response.language,
      components: response.components,
    }
  }

  getAllByBusinessId(businessAccountId: string): Promise<WhatsappTemplate[]> {
    const basePath = `whatsapp/accounts/${businessAccountId}/templates/synchronization`;
    return fetchAllWhatsappTemplatesSynchronization(basePath, (path) => this.httpClient.get<unknown>(path)).then((rows) =>
      rows.map((it) => this.mapToWhatsappTemplate(it as WhatsappTemplate))
    );
  }

  add(item: PostWhatsappTemplate): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        await this.httpClient.post<PostWhatsappTemplate>(`templates`, item);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  delete(templateId: string, name: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        await this.httpClient.delete<PostWhatsappTemplate>(`templates/${templateId}/name/${name}`);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  getByName(whatsAppId: string, whatsAppMessageTemplateId: string): Promise<GetSelectedWhatsappTemplate> {
    return this.httpClient.get<GetSelectedWhatsappTemplate>(`whatsapp/accounts/${whatsAppId}/templates/${whatsAppMessageTemplateId}`)
      .then(data => this.mapToSelectedWhatsappTemplate(data));
  }

  update(id: string, item: PostWhatsappTemplate): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        await this.httpClient.put<PostWhatsappTemplate>(`templates/${id}`, item);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }
}
